export default __webpack_public_path__ + "static/media/delete-icon.db147365.svg";